import type { ProductTaxonomyRenameDefinition } from '../types';

export const profileActivityRename = {
  copy: {
    'nav.review.activityLogs': {
      current: 'Activity logs',
      future: 'Profile activity',
    },
    // Builder-sandbox "Activity logs" onboarding panel. These are title-level references to
    // the feature, so the future variant follows the page name ("Profile activity"), matching
    // the nav and cmd-K — unlike the Ember descriptive copy, which renames to bare "activity".
    // current values are preserved byte-for-byte (note the lowercase "logs" in the heading).
    'activityLogs.onboardingTitle': {
      current: 'Activity logs',
      future: 'Profile activity',
    },
    'activityLogs.onboardingViewAll': {
      current: 'View all activity logs',
      future: 'View all profile activity',
    },
  },
  routes: {
    'profileActivity.index': {
      current: '/workspaces/:workspaceId/journeys/activity_logs',
      future: '/workspaces/:workspaceId/journeys/profile_activity/identified',
    },
    'profileActivity.identified': {
      current: '/workspaces/:workspaceId/journeys/activity_logs/identified',
      future: '/workspaces/:workspaceId/journeys/profile_activity/identified',
    },
  },
  sideNavItemIds: {
    logs: 'profile-activity',
  },
} as const satisfies ProductTaxonomyRenameDefinition;
